module.exports = __webpack_public_path__ + "img/helmet.fc3316d8.png";